import { RootState } from "../store";

export const selectDataFormData = (state: RootState) => state.data.formData;